<div class="user-detail">
    <div class="table-section  table-responsive table-sticky px-0 pt-0 mt-0" style="max-height: 200px;">
        <table class="table table-default table-user mb-0">
        <thead>
            <tr>
                <th>Document Type</th>
                <th>DocumentName</th>
                <th>Uploaded Date</th>
                <th>Expiry Date</th>
                <th>Renewal Date</th>
                <th *ngIf="isDeleteAction" width="56px">Action</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of data ;let i = index" [attr.title]="item.shortDescr ||item.shortdesc">
                <td *ngIf="item.documentType=='Other'">{{item.documentType}}({{item.documentName}})</td>
                <td *ngIf="item.documentType!='Other'">{{item.documentType}}</td>
                <td class="align-items-center">
                    File
                    <button *ngIf="isLogin"
                        class="btn btn-icon-text btn-light-success btn-sm pointer ml-2"
                        matTooltip="Download"
                        (click)="downloadDocument(item,i)">
                        <span class="material-symbols-outlined">download</span>
                    </button>
                </td>
                <td>{{item.uploadedDate | date: 'MM/dd/yyyy'}}</td>
                <td>{{item.expiryDate | date: 'MM/dd/yyyy'}}</td>
                <td>{{item.renewalDate | date: 'MM/dd/yyyy'}}</td>
                <td *ngIf="isDeleteAction">
                    <span class="textLink text-danger pointer" (click)="deletePopUp(i,item)"><span class="material-symbols-outlined">
                    delete
                    </span></span></td>
            </tr>
            <tr *ngIf="data?.length === 0">
                <td colspan="3" class="nofoundTxt"><i class="far fa-frown mr-1"></i> No Data Found.</td>
            </tr>
        </tbody>
    </table><br>
</div>
</div>
